const main_view = {
    template: require('./view.html'),
    controller: [
        "$scope",
        "offers_api",
        "chartFilters",
        "$stateParams",
        function ($scope, offers_api, chartFilters, $stateParams) {
            $scope.data = {};
            $scope.update_offers_chain_data = function (model) {
                offers_api.offers_chain_data({offers_chain_id: $stateParams.offers_chain_id, filters: model})
                .then(function (resp) {
                    $scope.data = resp;
                });
            };
            chartFilters.onChangeChartParams(
                "update_offers_chain_data",
                $scope.update_offers_chain_data
            );
            $scope.update_offers_chain_data(chartFilters.get_chart_filters());
        },
    ],
};
const state_config = {
    url: "/offers_chains/:offers_chain_id",
    reloadOnSearch: false,
    data: {
        priority: 801,
        title: "Offer Chains",
        role: "offers",
    },
    views: {
        '': main_view,
    },
};
export default state_config;
